import styled from 'styled-components';
import { Input, Button } from 'antd';

const Search = Input.Search;

export const AddItemDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`;

export const ReloadBtn = styled(Button)`
  margin-right: 1em;
`;

export const SpanItem = styled.span`
margin-right: 1em
margin-left: 1em
color:white
`;

export const AssetDeviceFlowSearch = styled(Search)`
  width: 42em;
`;

export const HomeSubMenu = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const HomeSubMenuCount = styled.div`
  width: 20px;
  height: 16px;
  border-radius: 6px;
  border-style: solid;
  border-width: 0.5px;
  justify-content: center;
  text-align: center;
  border-color: rgba(95, 92, 92, 0.65);
  display: flex;
  align-items: center;
  margin: 10px;
`;

export const StyledApplication = styled.div`
  background: #173049;
  margin: 20px;
  padding: 30px;
  min-height: 750px;
`;

export const StyledFormType = styled.div`
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.title.color};
  font-weight: ${(props) => props.theme.title.fontWeight};
`;

export const CardTitle = styled.div`
  padding: 0px 0px 6px;
  font-weight: bolder;
  color: ${(props) => props.theme.list.card.titleColor};
`;

export const CardFooterActions = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px;
`;


export const StyledSubForm = styled.div`
  background: ${(props) => props.theme.form.subSectionBackgroundColor};
  padding: 20px;
  min-height: 300px;
`;
